import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-select-sass/dist/js/bootstrap-select';

const loadDropdowns = () => {
  $('.selectpicker').selectpicker();
};

export default loadDropdowns;
